import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router-dom";

import { EPlatform, ERequestState, PedigreeRequestApi, PedigreeRequestDto, RequestDto } from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalRishRequestForm } from "./DrupalRishRequestForm";

export interface IDrupalRishRequestPageProps {}

export const DrupalRishRequestPage: React.FunctionComponent<IDrupalRishRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();

  const rishRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(PedigreeRequestApi);
  // TODO-CRR : saving is used, but not saveItem???
  const { data, loading, saving, refresh } = useCrudApi<PedigreeRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = rishRequestId) =>
          apiId > 0
            ? api.getPedigreeRequest(apiId)
            : new PedigreeRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: PedigreeRequestDto) => api.save(PedigreeRequestDto.fromJS({ ...d, isPortal: true })),
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.rishRequest}/${d.pedigreeRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: () => {},
      }),
      [api, rishRequestId]
    ),
    [rishRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.RISHRequest)}`}>
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={<DrupalRishRequestForm rishRequestId={rishRequestId} initialdata={data} loading={saving} />}
              requestDto={data?.request}
              bill={null}
              onStatusUpdated={refresh}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
